import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=20e6e8ba&"
import script from "./ProfileForm.vue?vue&type=script&lang=js&"
export * from "./ProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=20e6e8ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports